import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';

import { bibShape, holdItemShape } from '@bibliocommons/bc-prop-types';
import { selectActiveHoldsByMetadataId } from 'app/selectors/HoldsSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';

import TitleTransactionButton from './TitleTransactionButton';

export class TitleTransactionButtonContainer extends React.PureComponent {
  render() {
    return <TitleTransactionButton {...this.props} />;
  }
}

TitleTransactionButtonContainer.propTypes = {
  metadataId: PropTypes.string.isRequired,
  bib: bibShape.isRequired,
  block: PropTypes.bool,
  isLoading: PropTypes.bool,
  holdItem: holdItemShape
};

const mapStateToProps = (state, ownProps) => {
  const holds = selectActiveHoldsByMetadataId(state).get(ownProps.metadataId, Immutable.List());

  return {
    isLoading: state.getIn(['bibs', 'userTransactions', 'isFetching'], false),
    bib: selectBibEntities(state).get(ownProps.metadataId),
    holdItem: holds.size === 1 ? holds.first() : null
  };
};

export default connect(mapStateToProps)(TitleTransactionButtonContainer);
